// src/pages/ARPage.js
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import StlViewerAR from './3dfyrionvisor'; // ajusta la ruta si lo tienes en otro lado

const ARPage = () => {
  const [params] = useSearchParams();
  const modelo = params.get("modelo"); // URL del STL en Firebase
  const color = `#${params.get("color")}`; // Color en hex (sin el #)

  return (
    <div>
      <StlViewerAR stlUrl={modelo} color={color} />
    </div>
  );
};

export default ARPage;
